import { PageHeader } from "@ant-design/pro-components";
import { Button, Col, Divider, Flex, Input, List, Row } from "antd";
import { observer } from 'mobx-react';
import React, { useEffect, MouseEvent } from "react";
import Subjects from "../../models/subjects";
import { useStore } from "../../stores/root-store";
import '../common/page-header.css';
import StudentItem from "./student-item";
import Pagination from "../../models/pagination";

const StudentList: React.FC<{ subject: Subjects }> = ({ subject }) => {

    const { subjectStores, authStore } = useStore();
    const studentsList = subjectStores[subject].studentsList;

    useEffect(() => {
        if (authStore.isAuthenticated) {
            studentsList.loadList(1);
        }
    }, [studentsList, authStore.isAuthenticated]
    );

    const handleCreate = (event: MouseEvent<HTMLAnchorElement>) => {
        studentsList.createStudent();
    }

    const handleInputNewStudent = (event: React.ChangeEvent<HTMLInputElement>) => {
        studentsList.changeNewStudentName(event.target.value);
    }

    return (
        <div className="content">
            <PageHeader title="Ученики" className="site-page-header" />
            <Row>
                <Col span={8}>
                    <Flex justify="flex-start" gap="small">
                        <Input placeholder="введите имя ученика" className="basic-contol" onChange={handleInputNewStudent} value={studentsList.newStudentName}/>
                        <Button type="primary" onClick={handleCreate}>Добавить</Button>
                    </Flex>
                </Col>
            </Row>
            <Divider/>
            <List
                itemLayout="vertical"
                dataSource={studentsList.data}
                pagination={{
                    onChange: (page) => {
                        studentsList.loadList(page);
                    },
                    current: studentsList.currentPage,
                    pageSize: Pagination.PAGE_SIZE,
                    total: studentsList.totalCount
                }}
                renderItem={(item, indx) => (
                    <StudentItem {...{ item: item, indx: indx, subject: subject }} />
                )}
            ></List>
        </div>
    );
};


export default observer(StudentList);